import { AnyAction } from 'redux';

import {
    NEWS_POST_DETAIL_CREATE,
    NEWS_POST_DETAIL_ERROR,
    NEWS_POST_DETAIL_FETCH,
    NEWS_POST_DETAIL_RECEIVE,
    NEWS_POST_DETAIL_RESET,
    NEWS_POST_DETAIL_UPDATE,
} from './news-post-detail-actions';
import { NewsPost } from '../../models/news-post';

export interface NewsPostDetailReducerState {
    newsPost: NewsPost | null;
    requesting: boolean;
}

const initialNewsPostDetailReducerState: NewsPostDetailReducerState = {
    newsPost: null,
    requesting: false,
};

export const newsPostDetailReducer = (
    state: NewsPostDetailReducerState = initialNewsPostDetailReducerState,
    action: AnyAction
): NewsPostDetailReducerState => {
    switch (action.type) {
        case NEWS_POST_DETAIL_RESET: {
            return {
                ...state,
                newsPost: null,
            };
        }

        case NEWS_POST_DETAIL_CREATE:
        case NEWS_POST_DETAIL_FETCH:
        case NEWS_POST_DETAIL_UPDATE: {
            return {
                ...state,
                requesting: true,
            };
        }

        case NEWS_POST_DETAIL_RECEIVE: {
            return {
                ...state,
                requesting: false,
                newsPost: action['newsPost'],
            };
        }

        case NEWS_POST_DETAIL_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
